import React from 'react'
import { BrowserRouter, Route, Redirect } from "react-router-dom";
import SignatureScreen from './pages/assinatura'
import SelfieScreen from './pages/selfie'
import Auth from './pages/auth'
import Tutorial from './pages/tutorial'
import Documento from './pages/documento'
import { isAuthenticated } from './utils'
import Conclusao from './pages/conclusao'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
);

const Router = () => {
    return (
        <BrowserRouter>
            <Route path="/" exact component={Tutorial} />
            <Route path="/auth" exact component={Auth} />
            <PrivateRoute path="/assinatura" exact component={SignatureScreen} />
            <PrivateRoute path="/selfie" exact component={SelfieScreen} />
            <PrivateRoute path="/documento" exact component={Documento} />
            <Route path="/conclusao" component={Conclusao} />
        </BrowserRouter>
    )
}

export default Router